import { render, staticRenderFns } from "./BankFloatBtns.vue?vue&type=template&id=5f0ffbc4&"
import script from "./BankFloatBtns.vue?vue&type=script&lang=js&"
export * from "./BankFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports